module.exports = __webpack_public_path__ + "img/edge_nature_montagne.61d41f61.svg";